import { DescriptionSlide } from "src/pods/conundrums/components/DescriptionSlide";
import { IntroSlide } from "src/pods/conundrums/components/IntroSlide";
import { PairShareSlide } from "src/pods/conundrums/components/PairShareSlide";
import { ShareToStorySlide } from "src/pods/conundrums/components/ShareToStorySlide";
import { Slide } from "src/pods/conundrums/components/types";
import introFoods from "src/pods/conundrums/assets/introFoods@2x.jpg";
import introMain from "src/pods/conundrums/assets/introFoodsEmpty@2x.jpg";
import introFoodsEmpty from "src/pods/conundrums/assets/introFoodsEmpty@2x.jpg";
import mojoConundrumHero from "src/pods/conundrums/assets/mojoConundrumHero.svg";

export const Title = "Intro Conundrum";
export const Description = "What is a conundrum? Teach your students by presenting them with a difficult choice";

const activities: Slide[] = [
  IntroSlide(Title, Description, "", introMain, undefined, "5-10"),
  DescriptionSlide(
    "A conundrum is a question that is hard to answer. Often, there is no right answer!",
    mojoConundrumHero,
  ),
  DescriptionSlide("Write down your two favorite foods. It can be anything!", introFoods),
  DescriptionSlide(
    "One of these foods you will never eat again… which would you choose? Why?",
    introFoodsEmpty,
    "I'd never eat _____ again because...",
  ),
  PairShareSlide("Was it hard to choose? Why or why not?\nWhat else did you notice?"),
  ShareToStorySlide(
    "Congrats on completing this Conundrum!",
    "Now that was an interesting question indeed.",
    "https://static.classdojo.com/img/introConundrumShare.png",
    "Great discussion!",
  ),
];

export default activities;
